import { createApp } from 'vue'
import View from './View.vue'

;(function () {
  function safeParse(s) { try { return JSON.parse(s || '{}') } catch { return {} } }

  function applyThemeBridge(host) {
    // Let Drupal's page fonts bleed into the component via CSS vars.
    try {
      const bodyCS = getComputedStyle(document.body)
      if (bodyCS.fontFamily) host.style.setProperty('--drupal-font-sans', bodyCS.fontFamily)
      // (Optional) If you expose other tokens in Drupal, mirror them here as well, e.g.:
      // host.style.setProperty('--drupal-font-serif', ...);
      // host.style.setProperty('--drupal-font-mono', ...);
      // host.style.setProperty('--drupal-color-foreground', getComputedStyle(document.body).color);
    } catch {}
  }

  function mountInShadow(host, cssHref) {
    if (!host.attachShadow || host.hasAttribute('data-no-shadow')) return null
    if (host.shadowRoot) {
      // Reuse existing shadow (e.g., AJAX attach)
      const mp = host.shadowRoot.querySelector('[data-app]') || host.shadowRoot.firstElementChild
      return { shadow: host.shadowRoot, mountPoint: mp }
    }

    const shadow = host.attachShadow({ mode: 'open' })
    const bleed = (host.getAttribute('data-bleed') || 'on').toLowerCase()
    // 'on'  = allow Drupal -> component token bridge
    // 'off' = isolate (no bridge)
    if (bleed !== 'off') {
      host.classList.add('use-theme') // activates :host(.use-theme) bridge rules in CSS
      applyThemeBridge(host)
    }

    // Inject stylesheet inside the shadow (no global bleed)
    if (cssHref) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = cssHref
      shadow.appendChild(link)
    }

    // Mount point inside the shadow
    const mountPoint = document.createElement('div')
    mountPoint.setAttribute('data-app', '')
    mountPoint.className = 'cta-component'
    shadow.appendChild(mountPoint)

    return { shadow, mountPoint }
  }

  function mountAll(context) {
    const settings = (window.drupalSettings?.aryzac_pwc_cta) || {}
    const map = settings.views || {}
    const assetBase = settings.assetBase || ''
    const cssHref = assetBase ? `${assetBase}/dist/view.css` : null

    Object.values(map).forEach(cfg => {
      const root = (context || document).querySelector?.(`#${CSS.escape(cfg.targetId)}`) || document.getElementById(cfg.targetId)
      if (!root) return
      if (root.dataset.vueMounted === '1') return

      const data = safeParse(cfg.data)

      // Prefer Shadow DOM; fall back to light DOM if not supported / opted out.
      const shadowMount = mountInShadow(root, cssHref)
      const mountTarget = shadowMount ? shadowMount.mountPoint : root

      // Light DOM fallback: add wrapper class and optional theme bridge
      if (!shadowMount) {
        root.classList.add('cta-component')
        const bleed = (root.getAttribute('data-bleed') || 'on').toLowerCase()
        if (bleed !== 'off') {
          root.classList.add('use-theme')
          applyThemeBridge(root)
        }
      }

      createApp(View, { data }).mount(mountTarget)

      root.dataset.vueMounted = '1'
      const loading = root.querySelector('.aryzac_pwc_cta-loading')
      loading?.remove()
    })
  }

  const Drupal = window.Drupal || {}
  Drupal.behaviors = Drupal.behaviors || {}
  Drupal.behaviors.aryzac_pwc_ctaView = { attach(context) { mountAll(context) } }

  if (!window.Drupal) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountAll(document))
    } else {
      mountAll(document)
    }
  }
})()
